<template>
  <div 
    class="google-calendar-container"
    tabindex="0"
    role="region"
    aria-label="Cyclone RoboSub Google Calendar. Press Enter or Space to interact with the calendar."
    @keydown.enter="focusCalendar"
    @keydown.space.prevent="focusCalendar"
  >
    <iframe
      ref="calendarIframe"
      :src="calendarEmbedUrl"
      loading="lazy"
      style="border-width:0"
      width="600"
      height="600"
      scrolling="no"
      tabindex="-1"
      title="Cyclone RoboSub Google Calendar"
    ></iframe>
  </div>
</template>

<script>
export default {
  name: 'GoogleCalendarEmbed',
  props: {
    // You can make the calendar ID or URL dynamic if needed
    calendarId: {
      type: String,
      default: 'c_cd6266a79df7397e769762d0f962cc473f2879281dda4c9f4a7c7e49a58c5c49@group.calendar.google.com' // Replace with your actual calendar ID
    },
    // Example of a prop for customizing the view (month, week, agenda)
    view: {
      type: String,
      default: 'month'
    },
    showTitle: {
      type: [Boolean, Number], // Accepts true/false or 1/0
      default: false // Default to hiding the title
    }
  },
  computed: {
    calendarEmbedUrl() {
      const id = this.calendarId || this.$store?.state?.general?.calendarId || 'c_cd6266a79df7397e769762d0f962cc473f2879281dda4c9f4a7c7e49a58c5c49@group.calendar.google.com';
      // Construct the URL based on your calendar ID and other parameters
      // This is a simplified example, refer to Google Calendar embed documentation for full options
      return `https://calendar.google.com/calendar/embed?src=${id}&ctz=America%2FLos_Angeles&mode=${this.view}&showTitle=${this.showTitle}&showPrint=0&`;
    }
  },
  methods: {
    focusCalendar() {
      if (this.$refs.calendarIframe) {
        this.$refs.calendarIframe.focus();
      }
    }
  }
};
</script>

<style scoped>
.google-calendar-container {
  /* Add any styling for your container */
  width: 100%;
  max-width: 600px; /* Example max-width */
  margin: 0 auto;
  outline: none;
}

.google-calendar-container:focus-visible {
  outline: 2px dashed var(--regular, #02979d);
  outline-offset: 4px;
  border-radius: var(--border-radius-md, 8px);
}

iframe {
  width: 100%;
  height: 400px; /* Or a more responsive height */
  border-radius: var(--border-radius-md, 8px);
  display: block;
}

@media screen and (max-width: 640px) {
  iframe {
    height: 320px;
  }
}
</style>